(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.irisColorwayCardBound) {
    window.irisColorwayCardBound = true;

    var irisSwapCardImage = function (img, newUrl) {
      var base = newUrl.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      if (img.srcset) {
        img.srcset = img.srcset
          .split(',')
          .map(function (entry) {
            var descriptor = entry.trim().split(/\s+/)[1];
            var width = parseInt(descriptor, 10);
            if (!width) return null;
            return base + sep + 'width=' + width + ' ' + descriptor;
          })
          .filter(Boolean)
          .join(', ');
      }
      img.src = base + sep + 'width=1200';
    };

    document.addEventListener('click', function (event) {
      var swatchEl = event.target.closest('[data-iris-colorway]');
      if (!swatchEl) return;
      var card = swatchEl.closest('.product-card, .iris-pcard');
      if (!card) return; // PDP picker clicks are handled by the variant-picker block

      event.preventDefault();

      var images = (swatchEl.dataset.images || '')
        .split('|')
        .map(function (url) {
          return url.trim();
        })
        .filter(Boolean);
      card.querySelectorAll('.card-gallery slideshow-slide img, .iris-pcard__img').forEach(function (img, index) {
        var newUrl = images[index] || images[0];
        if (newUrl) irisSwapCardImage(img, newUrl);
      });

      var targetUrl = swatchEl.dataset.url;
      if (targetUrl) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
          if (link.hasAttribute('data-iris-colorway') || link.closest('product-swatches')) return;
          link.href = targetUrl;
        });
      }

      var priceEl = card.querySelector('product-price, .iris-pcard__price');
      if (priceEl && swatchEl.dataset.price && priceEl.textContent.trim() !== swatchEl.dataset.price.trim()) {
        priceEl.textContent = swatchEl.dataset.price.trim();
      }

      var sizeVariants = {};
      try {
        sizeVariants = JSON.parse(swatchEl.dataset.sizeVariants || '{}');
      } catch (error) {
        sizeVariants = {};
      }
      var qa = card.querySelector('.iris-qa');
      if (qa) {
        delete qa.dataset.variantId;
        qa.querySelectorAll('.iris-qa__size').forEach(function (button) {
          button.setAttribute('aria-pressed', 'false');
          var entry = sizeVariants[button.textContent.trim()];
          if (entry && entry.available) {
            button.disabled = false;
            button.dataset.variantId = entry.id;
          } else {
            button.disabled = true;
            delete button.dataset.variantId;
          }
        });
      }

      var root = swatchEl.closest('product-swatches, .iris-pcard__swatches');
      if (root) {
        root.querySelectorAll('.iris-colorway-selected').forEach(function (el) {
          el.classList.remove('iris-colorway-selected');
        });
        if (swatchEl.hasAttribute('data-current')) {
          root.removeAttribute('data-swapped');
        } else {
          swatchEl.classList.add('iris-colorway-selected');
          root.setAttribute('data-swapped', '');
        }
      }
    });
  }

  if (!window.irisQuickAddBound) {
    window.irisQuickAddBound = true;

    var closeIrisQa = function (qa) {
      qa.classList.remove('iris-qa--open');
      var gallery = qa.closest('.card-gallery, .iris-pcard__media');
      var toggle = gallery && gallery.querySelector('.iris-qa-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };

    document.addEventListener('click', async function (event) {
      var toggleButton = event.target.closest('.iris-qa-toggle');
      if (toggleButton) {
        event.preventDefault();
        var toggleGallery = toggleButton.closest('.card-gallery, .iris-pcard__media');
        var toggleQa = toggleGallery && toggleGallery.querySelector('.iris-qa');
        if (!toggleQa) return;
        var isOpen = toggleQa.classList.toggle('iris-qa--open');
        toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.querySelectorAll('.iris-qa--open').forEach(function (other) {
          if (other !== toggleQa) closeIrisQa(other);
        });
        return;
      }

      if (!event.target.closest('.iris-qa')) {
        document.querySelectorAll('.iris-qa--open').forEach(closeIrisQa);
      }

      var sizeButton = event.target.closest('.iris-qa__size');
      if (sizeButton && !sizeButton.disabled) {
        event.preventDefault();
        var sizeQa = sizeButton.closest('.iris-qa');
        sizeQa.querySelectorAll('.iris-qa__size[aria-pressed="true"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        sizeButton.setAttribute('aria-pressed', 'true');
        sizeQa.dataset.variantId = sizeButton.dataset.variantId;
        return;
      }

      var addButton = event.target.closest('.iris-qa__add');
      if (!addButton || addButton.dataset.busy) return;
      event.preventDefault();

      var qa = addButton.closest('.iris-qa');
      var variantId = Number(qa.dataset.variantId);
      if (!variantId) {
        qa.classList.add('iris-qa--need-size');
        setTimeout(function () {
          qa.classList.remove('iris-qa--need-size');
        }, 500);
        return;
      }

      addButton.dataset.busy = 'true';
      var originalText = addButton.textContent;
      addButton.textContent = '…';

      try {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!addResponse.ok) throw new Error('add failed');

        var cart = await (await fetch('/cart.js')).json();

        var updateEvent = new Event('cart:update', { bubbles: true });
        updateEvent.detail = {
          resource: cart,
          sourceId: 'iris-quick-add',
          data: { source: 'iris-quick-add', itemCount: cart.item_count, variantId: variantId },
        };
        document.dispatchEvent(updateEvent);

        addButton.textContent = 'Added ✓';
        setTimeout(function () {
          addButton.textContent = originalText;
          delete addButton.dataset.busy;
          closeIrisQa(qa);
        }, 1500);
      } catch (error) {
        addButton.textContent = originalText;
        delete addButton.dataset.busy;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!window.irisColorwayPdpBound) {
    window.irisColorwayPdpBound = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest('variant-picker a[data-iris-colorway]');
      if (!link) return;

      var picker = link.closest('variant-picker');
      var sizeInput = Array.prototype.find.call(
        picker.querySelectorAll('input[type="radio"]:checked'),
        function (input) {
          return input.name.toLowerCase().indexOf('size') === 0;
        }
      );
      if (!sizeInput) return;

      var sizeVariants = {};
      try {
        sizeVariants = JSON.parse(link.dataset.sizeVariants || '{}');
      } catch (error) {
        return;
      }
      var entry = sizeVariants[sizeInput.value];
      if (!entry || !entry.id) return;

      event.preventDefault();
      window.location.href = link.getAttribute('href').split('?')[0] + '?variant=' + entry.id;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
